import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    estatusDerivaciones: [],
  },

  getters: {
    getEstatusDerivaciones: (state) => state.estatusDerivaciones,
  },

  mutations: {
    SET_ESTATUS_DERIVACIONES(state, estatusDerivaciones) {
      state.estatusDerivaciones = estatusDerivaciones;
    },
  },

  actions: {
    async fetchEstatusDerivaciones({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catestatusDervicaciones')
        .then((response) => {
          commit('SET_ESTATUS_DERIVACIONES', response.data.data);
        });
    },
  },
};
